import type { TOC } from '@ember/component/template-only';
import CollectionsList from '../components/collections-list.gts';
import MobileHeader from '../components/mobile-header.gts';

interface Signature {
  Args: {};
}

const CollectionsTemplate: TOC<Signature> = <template>
  <MobileHeader @title="Collections" />
  <h1 class="mb-6 hidden text-3xl font-bold lg:block">Collections</h1>
  <CollectionsList />
</template>;

export default CollectionsTemplate;
